<template>
  <SmallSquare class="" content='关键词自动回复调用到的图文、图片素材，请不要随便删除或编辑内容，否则设置的回复会失效。'></SmallSquare>
  <div class="s_flex_bian_c m-t-20 m-b-20">
    <a-button type="primary" v-has:keyReplyAdd='()=>{replyVisible = true}'>
      <PlusOutlined />添加规则</a-button>
    <a-button type="primary" ghost v-has:wxReplySynchro="()=>{$router.push('/wxPublic/wxBase/index')}">同步微信内容</a-button>
  </div>
  <!-- 规则列表 -->
  <a-spin :spinning="listLoading">
    <div class="m-t-30" v-for='(item,index) in list' :key='index'>
      <a-spin :spinning="item.listLoading">
        <div class="s_bor_cbed">
          <div class="s_bf58 s_flex_bian_c height-40 s_bb1 s_ptb0lr24">
            <div class="s_flex_ali s_omit">
              <FileTextFilled class="fz-18 m-r-10" />
              <p class="fz-16 ">{{item.rule_name}}</p>
            </div>
            <div v-has:keyReplyDetail='()=>getMore(index)'>
              <DownOutlined class="s_shou" v-if='!item.open' />
              <UpOutlined class="s_shou" v-else />
            </div>
          </div>
          <!-- 表单 -->
          <div class="p-t-20" v-if='item.open && listIndex == index'>
            <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-form-item label="规则名" help='规则名最多60个字'>
                <a-input v-model:value="form.rule_name" placeholder='请输规则名' type="text" :maxlength="60" />
              </a-form-item>
              <a-form-item label="关键字">
                <div class="s_bor_cd9 m-t-5">
                  <div class="height-32 p-l-11 p-r-11 s_flex_ali">
                    <a href="javascript:;" @click='addKeysOpen("")'>添加关键字</a>
                  </div>
                  <div>
                    <div class="s_flex_bian_c height-32 p-l-11 p-r-11 s_bor_t_cd9"
                      v-for='(items,indexs) in form.keywords' :key='indexs'>
                      <p class="width50 s_omit">{{items.name}}</p>
                      <div>
                        <a-button type="link" @click='items.is_matching = items.is_matching ? 0 : 1'>
                          {{items.is_matching ? '已全匹配':'未全匹配'}}</a-button>
                        <EditOutlined class="m-r-30 fz-16 m-l-20" @click='addKeysOpen(indexs)' />
                        <DeleteFilled class="fz-16" />
                      </div>
                    </div>
                  </div>
                </div>
              </a-form-item>
              <a-form-item label="回复">
                <div class="s_bor_cd9 ">
                  <div class="height-38 s_flex_bian_c m-t-2 p-l-11 p-r-11">
                    <div class="s_flex_ali">
                      <p class="width-120 s_shou" @click='addTextOpen("")'>
                        <EditOutlined class="m-r-10 fz-16" />文字</p>
                      <div class="width-120 s_shou s_po_re">
                        <PictureOutlined class="m-r-10 fz-16" />图片
                      <div class="s_po_ab_tl s_tou" v-if='form.replys.length < 5'>
                        <wxMaterial :size='{width:120,height:40}' :groupType='1' :image="file_url" :max="1"
                          v-on:handlechoose="selectImg" />
                      </div>
                      <div v-else class="s_po_ab_tl s_tou width-120 height-40" @click='openSelectImgText'></div>
                      </div>
                      <p class="width-120 s_shou" @click='openSelectImgText'>
                        <FileImageOutlined class="m-r-10 fz-16" />图文</p>
                         <!-- 音频 -->
                        <p class="width-120 s_shou" @click="audioOpen=true">
                        <CustomerServiceOutlined class="m-r-10 fz-16" />音频</p>
                        <!-- 视频 -->
                        <p class="width-120 s_shou" @click="videoOpen=true">
                        <PlaySquareOutlined class="m-r-10 fz-16" />视频</p>
                    </div>
                    <a-checkbox v-model:checked="form.reply_all" @change="onChange">全部回复</a-checkbox>
                  </div>
                  <div>
                    <div class="p-t-10 p-l-24 p-b-10 p-r-24 s_bor_t_cd9 s_flex_bian"
                      v-for='(items,indexs) in form.replys' :key='indexs'>
                      <div class="clearfix width90">
                        <p class="fl width5">{{items.type_name}}</p>
                        <p class="fl width95" v-if='items.type== 1'>{{items.content}}</p>
                        <p class="fl" v-if='items.type== 3 || items.type== 4'>{{items.title}}</p>
                        <img v-if='items.type== 2' class="width-110 height-110" :src="items.image.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+items.image : items.image" alt="">
                           <p class="fl" v-if='items.type== 5'>{{items.title}}</p>
                           <p class="fl" v-if='items.type== 6'>{{items.title}}</p>
                      </div>
                      <div>
                        <EditOutlined v-if='items.type== 1' @click='addTextOpen(indexs)' class="m-r-30 fz-16 s_shou" />
                        <DeleteFilled class="fz-16 s_shou" @click='delreplyItem(indexs,items)' />
                      </div>
                    </div>
                  </div>
                </div>
              </a-form-item>
            </a-form>
          </div>
          <!-- 列表数据 -->
          <div class="p-t-20" v-else>
            <a-form-item label="关键字" :label-col="labelCol" :wrapper-col="wrapperCol" style='margin-bottom: 0;'>
              <div class="s_flex_ali s_flex_wrap m-t-5">
                <div class="p-tb0-lr10 s_bf7 height-30 m-r-10 s_flex_center m-b-10" v-for='items in item.keywords'
                  :key='items'>{{items.name}}</div>
              </div>
            </a-form-item>
            <a-form-item label="回复" :label-col="labelCol" :wrapper-col="wrapperCol">
              <div class="s_flex_ali s_flex_wrap height-30">
                文字({{item.reply_text_count}})、图片({{item.reply_image_count}})、图文({{item.reply_graphic_senior_count+item.reply_graphic_count}})、音频({{item.reply_voice_count}})、视频({{item.reply_video_count}})
              </div>
            </a-form-item>
          </div>
          <div class="s_bf58 s_flex_bian_c height-50 s_bt1 s_ptb0lr24" v-if='item.open && listIndex == index'>
            <p>文字({{form.replys.filter(v=>v.type==1).length}})、 图片({{form.replys.filter(v=>v.type==2).length}})、
              图文({{form.replys.filter(v=>v.type==3).length+form.replys.filter(v=>v.type==4).length}})、 音频({{form.replys.filter(v=>v.type==5).length}})、 视频({{form.replys.filter(v=>v.type==6).length}})、</p>
            <div>
              <a-button class="m-r-20" type="primary" v-has:keyReplyEdit='()=>addKeyreply("edit")'>保存</a-button>
              <a-button type="primary" ghost v-has:keyReplyDel='()=>delKeyreply(item.id)'>删除</a-button>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
    <div v-if="list.length == 0" class='p-50'>
      <a-empty :description="false" />
    </div>
  </a-spin>
  <a-modal  :keyboard="false" title="添加文字回复" :width='800' centered v-model:visible="visible" destroyOnClose @ok="addTextItem"
    @cancel='textContent = "";textIndex = ""'>
    <div class="s_flex_bian_c m-b-25">
      <p></p>
      <div class="s_flex_ali">
        <p class="s_c666 m-r-10">{{title}}</p>
        <a-tooltip>
          <template #title>
            {{qpText}}
          </template>
          <QuestionCircleOutlined class="s_c376" />
        </a-tooltip>
      </div>
    </div>
    <a-textarea v-model:value="textContent" showCount :maxlength="600" :rows='8' placeholder='请输入' />
  </a-modal>
  <a-modal  :keyboard="false" title="添加关键字" centered v-model:visible="visibleKey" destroyOnClose @ok="addKeyItem"
    @cancel='key_name = "";keysIndex = ""'>
    <a-input v-model:value="key_name" placeholder='请输入' :maxlength="10"/>
    <p class="s_c666 m-t-15 text-ar">最多10个字</p>
  </a-modal>
  <a-modal  :keyboard="false" title="选择图文" :width='1300' centered :footer="null" v-model:visible="graphicVisible" destroyOnClose>
    <graphic v-on:success='success' v-on:cancel='graphicVisible = false' />
  </a-modal>
  <a-modal  :keyboard="false" title="添加规则" :width='1300' centered :footer="null" v-model:visible="replyVisible" :destroyOnClose='true'>
    <keyReplyForm v-on:submit='submit'></keyReplyForm>
  </a-modal>

  <a-modal  :keyboard="false" title="选择音频" :width='1300' centered :footer="null" v-model:visible="audioOpen" destroyOnClose>
    <audioModal @change="audioSelect"></audioModal>
  </a-modal>

   <a-modal :keyboard="false" title="选择视频" :width='1300' centered :footer="null" v-model:visible="videoOpen" destroyOnClose>
    <videoModal :videoID='videoData.id'   @change="videoSelect"></videoModal>
  </a-modal>

</template>
<script>
  import { EditOutlined, PictureOutlined, FileImageOutlined, QuestionCircleOutlined, PlusOutlined, FileTextFilled, DownOutlined, UpOutlined, DeleteFilled,CustomerServiceOutlined,PlaySquareOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getwx_Keyreply, wx_KeyreplyAdd, wx_KeyreplyEdit, wx_KeyreplyDel, getwx_KeyreplyMore } from '@/api/public_wx'
  import keyReplyForm from './key_reply_form.vue';
  import store from "@/store";
     import audioModal from '../../menu/components/audioModal.vue';
    import videoModal from '../../menu/components/videoModal.vue';
  let defSearch = {
    page: 1,
    limit: 10
  };
  let defForm = {
    rule_name: '',
    keywords: [],
    replys: [],
    reply_all: 0
  }
  import { iscode } from "@/utils/app";
  export default {
    components: { EditOutlined, PictureOutlined, FileImageOutlined, QuestionCircleOutlined, PlusOutlined, FileTextFilled, DownOutlined, UpOutlined, DeleteFilled, keyReplyForm,audioModal,videoModal,CustomerServiceOutlined,PlaySquareOutlined },
    setup(props) {
      let search = ref({ ...defSearch });
      let form = ref({ ...defForm });
      const state = reactive({
        replyVisible: false,
        listIndex: null,
        file_url: '',
        keysIndex: '',
        textIndex: '',
        key_name: '',
        textContent: '',
        info: store.state.user.info,
        listLoading: false,
        labelCol: { span: 2 },
        wrapperCol: { span: 20 },
        visibleKey: false,
        visible: false,
        graphicVisible: false,
        title: '文字回复可以用标签 <#微信昵称#> 显示会员微信昵称哦~',
        qpText: '后台设置：<#微信昵称#>终于等到你！ 用户关注后：高大永恒塑料制品有限公司后台 终于等到你！',
        list: [],
        audioOpen:false,
        videoOpen:false,
        videoData:{id:null}
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      //  打开添加关键词
      const addKeysOpen = (index) => {
        if (index !== "") {
          state.visibleKey = true
          state.keysIndex = index
          state.key_name = form.value.keywords[index].name
        } else {
          if (form.value.keywords.length == 10) {
            message.error('最多只能添加10个关键词！');
          } else {
            state.visibleKey = true
          }
        }
      }
      // 添加关键词
      const addKeyItem = () => {
        if (state.key_name == '') {
          message.error('请输入所要添加的关键词！');
        } else {
          if (state.keysIndex === '') {
            form.value.keywords.push({ name: state.key_name, is_matching: 0 })
            state.visibleKey = false
            state.key_name = ''
            state.keysIndex == ''
          } else {
            form.value.keywords[state.keysIndex].name = state.key_name
            state.visibleKey = false
            state.key_name = ''
            state.keysIndex == ''
          }
        }
      }
      // 打开添加文字内容
      const addTextOpen = (index) => {
        if (index !== "") {
          state.visible = true
          state.textIndex = index
          state.textContent = form.value.replys[index].content
        } else {
          if (form.value.replys.length == 5) {
            message.error('每条规则最多设置5条回复');
          } else {
            state.visible = true
          }
        }
      }
      // 添加文字内容
      const addTextItem = () => {
        if (state.textContent == '') {
          message.error('文字必须为1到600个字。');
        } else {
          if (state.textIndex === '') {
            form.value.replys.push({ type: 1, content: state.textContent, type_name: "文字" },)
            state.visible = false
            state.textContent = ''
            state.textIndex == ''
          } else {
            form.value.replys[state.textIndex].content = state.textContent
            state.visible = false
            state.textContent = ''
            state.textIndex == ''
          }
        }
      }
      //选择图片
      const selectImg = (data) => {
        form.value.replys.push({ type: 2, content: data.data.media_id, type_name: "图片", image: data.imageUrl })
      }
      //选择图文
      const success = (e) => {
        form.value.replys.push({ type: e.media_id ? 3 : 4, content: e.media_id ? e.media_id : e.id, type_name: "图文", title: e.list[0].title })
        state.graphicVisible = false
      }
      // 打开选择图文
      const openSelectImgText = () => {
        if (form.value.replys.length == 5) {
          message.error('每条规则最多设置5条回复');
          return false
        }
        state.graphicVisible = true
      }
      // 删除回复
      const delreplyItem = (index,items) => {
        form.value.replys.splice(index, 1);
        if(items.type==6){
             state.videoData = {id:null}
        }
      }
      //添加规则
      const addKeyreply = async (type) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await wx_KeyreplyEdit({ ...form.value, keywords: JSON.stringify(form.value.keywords), replys: JSON.stringify(form.value.replys) }).then(res => res.data)
        if (iscode(res)) {
          setTimeout(hide);
          message.success(res.msg);
          initData(search.value)
        } else {
          setTimeout(hide);
          message.error(res.msg);
        }
      }
      //
      const submit = () => {
        message.success('添加成功');
        initData(search.value)
        state.replyVisible = false
      }
      // 删除规则
      const delKeyreply = async (e) => {
        $Modal.confirm({
          centered: true,
          title: '温馨提示',
          content: '您真的要删除该规则吗？', onOk: async () => {
            const hide = message.loading('正在加载中...', 0);
            let res = await wx_KeyreplyDel({ id: e }).then(res => res.data);
            if (iscode(res)) {
              setTimeout(hide);
              message.success(res.msg);
              initData(search.value)
            } else {
              setTimeout(hide);
              message.error(res.msg);
            }
          }
        })
      }
      //获取规则详情
      const getMore = async (index) => {
        var item = state.list[index]
        if (item.open) {
          item.open = false
          return false
        }
        item.listLoading = true
        let res = await getwx_KeyreplyMore({ id: item.id }).then(res => res.data);
        if (iscode(res)) {
          form.value = {
            rule_name: res.data.rule_name,
            keywords: res.data.keywords,
            replys: _lodash.concat(res.data.replyText || [], res.data.replyImage || [], res.data.replyGraphic || []),
            reply_all: res.data.reply_all,
            id: res.data.id
          }
          item.replyText = res.data.replyText
          item.replyImage = res.data.replyImage
          item.replyGraphic = res.data.replyGraphic
          item.open = true
          item.listLoading = false
          state.listIndex = index
        } else {
          item.listLoading = false
          message.error(res.msg);
        }
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getwx_Keyreply(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            for (var i in res.data.data) {
              res.data.data[i].open = false
              res.data.data[i].listLoading = false
            }
            state.list = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };

       const audioSelect = function(data){

           form.value.replys.push({ type: 5, content:data.media_id , type_name: "音频", title: data.name || '无' })
           state.audioOpen = false;
      }

      const videoSelect = function(data){
            state.videoData = data;
            form.value.replys.push({ type: 6, content:data.media_id , type_name: "视频", title: data.name || '无' })
             state.videoOpen = false;
      }

      onMounted(() => {
        initData(search.value)
      });
      return {
        ...toRefs(state),
        search,
        form,
        getMore,
        addKeysOpen,
        addKeyItem,
        addTextOpen,
        addTextItem,
        selectImg,
        success,
        openSelectImgText,
        addKeyreply,
        delreplyItem,
        delKeyreply,
        submit,
        videoSelect,
        audioSelect
      };
    },
  };
</script>